import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define the context type
interface FilterContextType {
  isShown: boolean;
  setShown: React.Dispatch<React.SetStateAction<boolean>>;
}

// Create the context with a default value
const FilterContext = createContext<FilterContextType | undefined>(undefined);

// Custom hook to use the FilterContext
export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilterContext must be used within a FilterProvider');
  }
  return context;
};

// Provider component
interface FilterProviderProps {
  children: ReactNode;
}

export const FilterProvider: React.FC<FilterProviderProps> = ({ children }) => {
  const [isShown, setShown] = useState(false);

  return (
    <FilterContext.Provider value={{ isShown, setShown }}>
      {children}
    </FilterContext.Provider>
  );
};
